<template>
    <div class="card-main-container scroll" >
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: "CardMain"

    }
</script>

<style lang="scss" scoped>
    .card-main-container {
        height: 34.495vh;
        background-color: var(--theme-bg);
        color: var(--theme-text);
    }
</style>